<template>
    <b-form-input
        @input="onTyping"
        v-model="value"
        :placeholder="placeholder"
    />
</template>

<script>
import {BFormInput} from 'bootstrap-vue'
export default {
    components: {BFormInput},
    props: {
        placeholder: {
            default() {
                return this.$t('Component(Placeholder):type-here')
            }
        },
        initialValue: {
            default: ''
        }
    },
    data() {
        return {
            timer: null,
            value: this.initialValue
        };
    },
    methods: {
        clear() {
            this.value = '';
        },
        onTyping(value) {
            if (this.timer) {
                clearTimeout(this.timer);
            }

            this.timer = setTimeout(() => {
                this.$emit('search', this.value);
            }, 500);
        }
    }
}
</script>
